import { render, staticRenderFns } from "./profitSucceed.vue?vue&type=template&id=5c5ba0d0&scoped=true"
import script from "./profitSucceed.vue?vue&type=script&lang=js"
export * from "./profitSucceed.vue?vue&type=script&lang=js"
import style0 from "./profitSucceed.vue?vue&type=style&index=0&id=5c5ba0d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_3rwm2qttujvjuolkwtduiruple/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5ba0d0",
  null
  
)

export default component.exports